<template>
  <div class="md-layout text-main-black">
    <div class="md-layout-item md-size-100 mobile-layout">
      <md-card class="mobile-card counters-card text-main-black">
        <md-card-content class="mobile-content">
          <div class="counters-card-wrapper">
            <table class="custom-dense-table counters-table">
              <thead>
              <tr class="md-theme-table-head-color">
                <th>Счетчики</th>
                <th style="width: 33%">Показания</th>
                <th class="hidden-sm">Дата</th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="(item,i) in loadData"
                :key="i"
                @click="clickRow(item)"
              >
                <td>
                  {{ item.kind.kindName }}
                  <small class="number-label text-grey-2">
                    {{ item.number ? `№${item.number}` : '' }}
                  </small>
                </td>
                <td>
                  <input
                    :id="`input_${item.id}`"
                    class="read-value-input"
                    v-model="item.newValue"
                    :placeholder="item.lastReadings.value"
                    type="number"
                  >
                  {{ item.kind.measureUnit }}

                  <span
                    v-if="item.newValue"
                    :class="{
                        'text-danger': item.kind.maxDelta < Number(item.newValue) || getDiff(item.lastReadings.value, item.newValue) < 0,
                        'text-success': getDiff(item.lastReadings.value, item.newValue) > 0 && Number(item.newValue) < item.kind.maxDelta
                      }">
                    {{ getDiff(item.lastReadings.value, item.newValue) > 0 ? '+' : '' }}
                    {{ getDiff(item.lastReadings.value, item.newValue) }}
                  </span>
                  <small class="date-label">
                    {{ item.lastReadings.createdAt | date }}
                  </small>
                </td>
                <td class="hidden-sm">
                  {{ item.lastReadings.createdAt | date }}
                </td>
              </tr>
              </tbody>
            </table>
            <div class="md-caption counters-note text-grey-1">
              {{ countersNote }}
            </div>
            <div class="text-align-center">
              <md-button @click.prevent="submitHandler">
                Отправить показания
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import to from "await-to-js";

export default {
  name: "CountersPage",
  data() {
    return {
      lastEditItemId: null
    }
  },
  computed: {
    ...mapGetters([
      "getCounters",
      "getManageOrganizationInfo"
    ]),

    countersNote() {
      if (this.getManageOrganizationInfo.hasOwnProperty("services")) {
        return this.getManageOrganizationInfo.services.counters.countersNote;
      }
      return false;
    },

    loadData() {
      return this.getCounters;
    }
  },
  methods: {
    async submitHandler() {
      const data = this.loadData
        .filter(counter => counter.newValue)
        .map(counter => ({
          id: counter.id,
          readings: { value: counter.newValue }
        }));

      if (data.length === 0) {
        this.$notifyDanger("Установите новые показания");
        return;
      }

      const [err] = await to(this.$store.dispatch("SAVE_COUNTERS", data));

      if (!err) {
        this.$notifySuccess("Показания обновлены");
      } else {
        this.$notifyDanger("Произошла ошибка");
      }
    },

    clickRow(item) {
      this.$nextTick(() => {
        const el = document.getElementById(`input_${item.id}`)
        el.focus();
      })
    },

    getDiff(oldValue, newValue) {
      return newValue ? Number((newValue - oldValue).toFixed(2)) : oldValue;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/md/variables";

.counters-card {
  max-width: 785px;
  @media (max-width: 768px) {
    background-color: transparent !important;
    box-shadow: unset;
  }
  .md-card-content {
    padding: 25px 20px;
    @media (max-width: 768px) {
      padding: 0 !important;
    }
  }
  &-wrapper {
    padding: 0 10px;
    @media (max-width: 768px) {
      padding: 10px 0 0 0;
    }
  }
  .counters-table {
    tbody {
      @media (max-width: 768px) {
        background-color: #ffffff;
      }
      td {
        @media (max-width: 768px) {
          border-right: 1px solid #eee;
        }
      }
    }
  }
  .custom-dense-table {
    tbody tr {
      cursor: pointer;
      border-bottom: 1px solid #eee;
    }
  }
  .counters-note {
    margin-top: 20px;
    text-align: left;
    white-space: pre-line;
    line-height: 12px;
    padding: 0 10px;
  }
  .read-value-input {
    width: 60px;
    height: 20px;
    border: 1px solid #eee;
    font-family: Roboto,Helvetica,Arial,sans-serif;
    font-size: 14px;
    color: #3c4858;
    &::placeholder {
      color: var(--md-theme-text-light-grey-color);
    }
  }
  .number-label {
    font-size: 14px;
    @media (max-width: 768px) {
      display: block;
    }
  }
  .date-label {
    display: none;
    color: #ccc;
    font-size: 14px;
    @media (max-width: 768px) {
      display: block;
    }
  }
}
</style>
